import { Box } from '@chakra-ui/react';

import { MitopureElaborationDesktop } from './Desktop';
import { MitopureElaborationMobile } from './Mobile';

export function MitopureElaboration() {
  return (
    <Box className="section--mitopure-elaboration" my="2xl">
      <Box display={{ lg: 'none' }}>
        <MitopureElaborationMobile />
      </Box>
      <Box display={{ base: 'none', lg: 'block' }}>
        <MitopureElaborationDesktop />
      </Box>
    </Box>
  );
}
